<template>
    <div>
        <v-row class="mt-1">
            <v-col cols="12" sm="3" md="3">
                <v-img v-if="editData.image" :src="editData.image" class="mt-3" min-height="180px" style="border:1px solid #BDBDBD"></v-img>
                <v-img v-if="!editData.image" src="" class="mt-3" min-height="180px" style="border:1px solid #BDBDBD"></v-img>
            </v-col>
            <v-col cols="12" sm="9" md="9" class="pl-12">
                <v-row>
                    <v-col cols="12" sm="3" md="3">
                        <!-- <div class="caption d-block grey--text text--darken-2">Listing ID</div>
                        <div class="d-block body-1">{{ editData.listing_id }}</div> -->
                        <v-text-field 
                            v-model="editData.listing_id" 
                            label="Listing ID"
                            style="width: 50%"
                            disabled
                            hide-details>
                        </v-text-field>
                        <div class='d-block mt-2 caption error--text'>{{ editData.listing_id == '' ? 'If not defined, new ID will be generated based on State & Year' : '' }}</div>
                        <div class="mt-4 d-block align-center">
                            <div v-if="editData.short_link_url" id="copy-url" class="d-inline">{{ editData.short_link_url }}</div> 
                            <v-tooltip
                                v-if="editData.short_link_url" 
                                v-model="trigger_copied"
                                right>
                                <template v-slot:activator="{ }">
                                    <div class="ml-3 d-inline">
                                        <v-icon style="font-size: 1.15rem" color="primary" @click="handleCopyUrl">mdi-content-copy</v-icon>
                                    </div>
                                </template>
                                <span>copied</span>
                            </v-tooltip>
                        </div>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" class="d-flex justify-start">
                        <v-text-field
                            v-model="sellerDataFirstname"
                            label="Seller First Name"
                            class="d-inline mr-2">
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" class="d-flex justify-start">
                        <v-text-field
                            v-model="sellerDataLastname"
                            label="Seller Last Name"
                            class="d-inline">
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" class="d-flex justify-end">
                        <v-switch 
                            :input-value="dataIsActive"
                            inset
                            color="success darken-2" 
                            label="Is Active"
                            @change="toggleActiveFlag($event)">
                        </v-switch>
                    </v-col>
                </v-row>
                <v-row> 
                    <v-col cols="12" sm="3" md="3" class="ml-0">
                        <v-menu
                            v-model="dateMenu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="editData.post_date"
                                    label="Post Date"
                                    append-icon="mdi-calendar"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on">
                                </v-text-field>
                            </template>
                            <v-date-picker
                                v-model="editData.post_date"
                                @input="dateMenu = false">
                            </v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" class="ml-0">
                        <v-select
                            v-model="editData.status"
                            :items="listing_statuses"
                            label="Status"
                            @change="toggleAcceptingFlag($event)">
                        </v-select>
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <v-switch 
                            v-model="editData.accepting_flag"
                            inset
                            :disabled="true"
                            color="success darken-2"
                            class="acceptingSwitch" 
                            label="Accepting Applications">
                        </v-switch>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" class="ml-0">
                        <v-select
                            v-model="editData.stage"
                            :items="listing_stages"
                            label="Stage">
                        </v-select>
                    </v-col>
                </v-row>
            </v-col>            
        </v-row>

        <v-row>
            <v-col cols="12" sm="6" md="6">
                <v-row>
                    <v-col class="d-flex">
                        <v-text-field 
                            v-model.lazy="dataAum" 
                            label="AUM"
                            :class="`mr-${[10, 12].includes(editData.listing_type) ? 10 : 0}`"
                            class="d-inline justify-start"
                            prepend-inner-icon="mdi-currency-usd">
                        </v-text-field>
                        <v-text-field 
                            v-if="[10, 12].includes(editData.listing_type)"
                            v-model.lazy="dataAua" 
                            label="AUA"
                            class="d-inline justify-end ml-10"
                            prepend-inner-icon="mdi-currency-usd">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-text-field 
                            v-model.lazy="dataRevenue"
                            label="Revenue"
                            prepend-inner-icon="mdi-currency-usd">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-text-field 
                            v-model="editData.title" 
                            label="Title"
                            counter
                            maxlength="54"
                            hint="Title field has a maxlength">
                        </v-text-field>
                    </v-col>
                </v-row>
            </v-col>

            <v-col cols="12" sm="6" md="6">
                <v-row>
                    <v-col>
                        <v-select
                            v-model="editData.listing_type"
                            :items="listing_types"
                            label="Listing Types">
                        </v-select>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-select
                            v-model="editData.state"
                            :items="states"
                            label="State"
                            required
                            :disabled="editData.id && editData.listing_id ? true : false"
                            :hint="editData.state == '' ? `<span class='error--text'>State is required</span>` : ''"
                            persistent-hint>
                        </v-select>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-textarea
                            v-model="editData.description"
                            label="Description"
                            auto-grow
                            rows="5">
                        </v-textarea>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>

        <v-row v-if="editData.status === 4">
            <v-col cols="12">
                <UploadDealHighlightsOfListing
                    :listingId="editData.listing_id"
                    :lastUploaded="editData.pdf_highlights_last_upload_date"
                />
            </v-col>
        </v-row>
    </div>
</template>

<script>
    import { 
        formatNumbers,
        scrubNumbers } from '../../helpers/utilities'

    import UploadDealHighlightsOfListing from '../partials/UploadDealHighlightsOfListing'

    export default {
        name: 'BasicInfo',

        components: {
            UploadDealHighlightsOfListing,
        },
        
        props: {
            editData: Object,
            states: Array,
            listing_statuses: Array,
            listing_stages: Array,
            listing_types: Array
        },

        data: () => ({
            dateMenu: false,
            trigger_copied: false
        }),
        
        computed: {
            dataAum: {
                get: function() {
                    return this.editData.aum != null ? formatNumbers(scrubNumbers(this.editData.aum)) : ''
                },
                set: function(val) {
                    this.swapNumbers('aum', val);
                    return val;
                }
            },
            dataAua: {
                get: function() {
                    return this.editData.aua != null ? formatNumbers(scrubNumbers(this.editData.aua)) : ''
                },
                set: function(val) {
                    this.swapNumbers('aua', val);
                    return val;
                }
            },
            dataRevenue: {
                get: function() {
                    return this.editData.revenue != null ? formatNumbers(scrubNumbers(this.editData.revenue)) : ''           
                },
                set: function(val) {
                    this.swapNumbers('revenue', val);
                    return val
                }
            },
            dataIsActive: {
                get: function() {
                    return this.editData.is_active
                },
                set: function(val) {
                    return val
                }
            },
            sellerDataFirstname: {
                get: function() {
                    return this.editData.sellerData != undefined ? this.editData.sellerData.seller_firstname : ''
                },
                set: function(val) {
                    this.editData.sellerData.seller_firstname = val
                    return val
                }
            },
            sellerDataLastname: {
                get: function() {
                    return this.editData.sellerData != undefined ? this.editData.sellerData.seller_lastname : ''
                },
                set: function(val) {
                    this.editData.sellerData.seller_lastname = val
                    return val
                }
            }
        },

        mounted () {
            // console.log(this.editData)
        },
        // created(){
        //     // Trick to remove class after initialising form
        //     this.$nextTick(() => {
        //         document.getElementById('acceptingSwitch').classList.remove('v-btn--disabled')
        //         document.getElementById('acceptingSwitch').classList.remove('success--text')
        //         document.getElementById('acceptingSwitch').classList.add('success darken-2')
        //     })
        // },

        methods: {
            swapNumbers: function (field, val) {
                this.editData[field] = scrubNumbers(val);
                // console.log(this.editData[field])
            },

            toggleAcceptingFlag: function (status_value) {
                switch (status_value) {
                    case 1:
                    case 2: {
                        this.editData.accepting_flag = true; break;
                    }
                    case 3:
                    case 4: 
                    case 5:
                    case 6: {
                        this.editData.accepting_flag = false; break;
                    }
                }
            },

            toggleActiveFlag: function (toggle_active) {
                this.editData.is_active = toggle_active
            },

            handleCopyUrl: function () {
                navigator.clipboard.writeText(document.querySelector('div#copy-url').innerText)
                this.trigger_copied = true;
                setTimeout(() => { this.trigger_copied = false; }, 2000);
            }
        }
    }
</script>

<style scoped>    
    .acceptingSwitch .v-input--selection-controls__input[disabled] {
        /* Override the disabled styling */
        background-color: #9cc04f !important;
        border-color: #9cc04f !important;
        color: black !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/prospectus-sections/BasicInfo.vue